export const BASE_URL = `https://fayton.click/api`;
export const LOCALITIES_URL = `${BASE_URL}/locality`;
export const SEASONS_URL = `${BASE_URL}/season`;
export const DIRECTIONS_URL = `${BASE_URL}/direction`;
export const STOPS_URL = `${BASE_URL}/stop`;
export const OPTIONS_URL = `${BASE_URL}/option`;
export const SECTORS_URL = `${BASE_URL}/sector`;
export const DRIVERS_URL = `${BASE_URL}/driver`;
export const ROUTES_URL = `${BASE_URL}/route`;
export const USERS_URL = `${BASE_URL}/user`;
export const PERMISSIONS_URL = `${BASE_URL}/permission`;
export const BLACKS_URL = `${BASE_URL}/black`;
export const BOOKINGS_URL = `${BASE_URL}/booking`;
export const TRIPS_URL = `${BASE_URL}/trip`;

export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
